import React from 'react';
import { Avatar, Dropdown, message } from 'antd';
import type { MenuProps } from 'antd';
import { 
  LogoutOutlined, 
  UserOutlined, 
  SettingOutlined,
  LockOutlined 
} from '@ant-design/icons';
import { history } from '@umijs/max';
import { useAuth } from '@/hooks/useAuth';

type RightContentProps = {
  collapsed?: boolean;
};

const RightContent: React.FC<RightContentProps> = ({ collapsed }) => {
  const { logout, user } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      message.success('Đăng xuất thành công!');
      history.push('/login');
    } catch (error) {
      console.error('Logout error:', error);
      message.error('Có lỗi xảy ra khi đăng xuất!');
    }
  };

  const handleChangePassword = () => {
    history.push('/change-password');
  };

  const handleUserProfile = () => {
    history.push('/profile');
  };

  const items: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Hồ sơ cá nhân',
      onClick: handleUserProfile,
    },
    {
      key: 'changePassword',
      icon: <LockOutlined />,
      label: 'Đổi mật khẩu',
      onClick: handleChangePassword,
    },
    // {
    //   key: 'settings',
    //   icon: <SettingOutlined />,
    //   label: 'Cài đặt',
    //   onClick: () => message.info('Tính năng cài đặt sẽ được phát triển sau!'),
    // },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Đăng xuất',
      onClick: handleLogout,
    },
  ];

  if (!user) {
    return null;
  }

  const displayName = user.user_metadata?.name || user.email?.split('@')[0] || 'User';
  const avatarUrl = user.user_metadata?.avatar_url;

  return (
    <Dropdown 
      menu={{ items }} 
      placement="bottomRight"
      arrow
      trigger={['click']}
    >
      <div 
        style={{ 
          display: collapsed ? 'block' : 'flex', 
          alignItems: 'center', 
          gap: '12px', 
          cursor: 'pointer',
          padding: collapsed ? 0: '6px 12px' ,
          borderRadius: '8px',
          transition: 'all 0.3s',
          width: '100%'
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.04)'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
      >
        <Avatar 
          size={40} 
          src={avatarUrl}
          icon={!avatarUrl && <UserOutlined />}
          style={{ 
            backgroundColor: !avatarUrl ? '#00AB82' : undefined,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            border: '2px solid #fff'
          }}
        />
        {!collapsed && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <span style={{ 
            fontSize: '15px', 
            fontWeight: 600, 
            color: '#1f1f1f',
            lineHeight: '1.2'
          }}>
            {displayName}
          </span>
          <span style={{ 
            fontSize: '12px', 
            color: '#8c8c8c',
            marginTop: '2px',
            maxWidth: '160px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            {user.email}
          </span>
          </div>
        )}
      </div>
    </Dropdown>
  );
};

export default RightContent;